import { render, staticRenderFns } from "./ShareBlock.vue?vue&type=template&id=6e0dc26c&scoped=true"
import script from "./ShareBlock.vue?vue&type=script&lang=js"
export * from "./ShareBlock.vue?vue&type=script&lang=js"
import style0 from "./ShareBlock.vue?vue&type=style&index=0&id=6e0dc26c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dc26c",
  null
  
)

export default component.exports